/**
 * Offers viewport related functions
 */


export default class ViewportOffset {

	/**
	 * Calculates the height of elements covering the top of the page, to be used as offset when
	 * computing scroll positions.
	 *
	 * @returns {number}
	 */
	static calculateOffset( $ignore = null ) {
		if ( $ignore === null ) {
			$ignore = jQuery();
		}
		let offset = 0;

		let $indicator = jQuery( '#main-navigation-indicator' );
		let $placeholder = jQuery( '#main-navigation-placeholder' );
		let $navigation = jQuery( '#main-navigation' );
		if ( ! $placeholder.is( $ignore ) ) {
			if ( $indicator.length ) {
				if ( $indicator.css( "position" ) === "fixed" ) {
					offset += $navigation.height();
				}
			} else if ( $navigation.length && $navigation.css( "position" ) === "fixed" ) {
				offset += $navigation.height();
			}
		}

		let $wpadminbar = jQuery( '#wpadminbar' );
		if ( ! $wpadminbar.is( $ignore ) ) {
			if ( $wpadminbar.length && $wpadminbar.css( "position" ) === "fixed" ) {
				offset += $wpadminbar.height();
			}
		}

		return offset;
	}
}
